import React from 'react';
import './page-header.css';

type PageHeaderProps = {
  title: string;
  right?: React.ReactNode;
  left?: React.ReactNode;
  subtitle?: string;
};

const PageHeader: React.FC<PageHeaderProps> = ({ title, right, left, subtitle }) => {
  return (
    <header className="page-header" role="banner">
      <div className="page-header__row">
        <div className="page-header__left">{left}</div>
        <div className="page-header__center">
          <h1 className="page-header__title">{title}</h1>
          {subtitle && <div className="page-header__subtitle">{subtitle}</div>}
        </div>
        <div className="page-header__right">{right}</div>
      </div>
    </header>
  );
};

export default PageHeader;


